import { BackNavLink } from '../NavButtons';
import { focusTheme } from '../../utils/focusTheme';
import ActivityAttachments from './ActivityAttachments';

function ActivityIntroScreen({
  attachments = [],
  attachmentsTitle = 'فایل‌های پیوست',
  backLabel,
  backTo,
  imageSrc,
  isStarting = false,
  onStart,
  startDisabled = false,
  startLabel,
  startingLabel = 'در حال شروع...',
  stats = [],
  statusMessage,
  subtitle,
  title,
}) {
  return (
    <div className="space-y-5">
      <BackNavLink to={backTo}>{backLabel}</BackNavLink>

      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-2">
          <p
            style={{ background: focusTheme.header.background, boxShadow: focusTheme.header.boxShadow }}
            className="px-6 py-1 rounded-[10px] text-[15px] text-white"
          >
            {title}
          </p>
          {imageSrc && <img className="h-[50px]" src={imageSrc} alt="" />}
        </div>

        <div>
          <p className="text-[17px] font-bold text-black">آماده‌ای شروع کنی؟</p>
          <p className="mt-2 text-[14px] font-medium leading-7 text-black">{subtitle}</p>
        </div>

        {stats.length > 0 && (
          <div
            className="grid grid-cols-2 gap-2 rounded-[8px] p-2"
            style={{ background: focusTheme.sectionBg }}
          >
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-[6px] px-3 py-2 text-slate-700"
                style={{ background: stat.background || focusTheme.stat.remaining }}
              >
                <p className="text-[12px] font-medium text-slate-700">{stat.label}</p>
                <p className="mt-1 text-[14px] font-bold text-slate-900">{stat.value}</p>
              </div>
            ))}
          </div>
        )}

        <ActivityAttachments attachments={attachments} title={attachmentsTitle} />

        {statusMessage && (
          <div className="rounded-[10px] bg-white p-4 text-center shadow-[0_4px_14px_rgba(15,23,42,0.06)]">
            <p className="text-[12px] font-bold text-slate-800">{statusMessage}</p>
          </div>
        )}

        {onStart && (
          <button
            type="button"
            onClick={onStart}
            disabled={startDisabled || isStarting}
            className={`w-11/12 mx-auto text-[14px] font-bold py-2.5 text-center flex items-center justify-center rounded-[8px] disabled:opacity-60 ${focusTheme.button.primary}`}
          >
            {isStarting ? startingLabel : startLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default ActivityIntroScreen;
